import * as React from 'react'
import {
  GridFooterPlaceholder,
  GridHeaderPlaceholder,
  GridRoot,
  GridBody,
} from '../components'
import { DataGridProps } from '../models/props/DataGridProps'
import { GridContextProvider } from '../context/GridContextProvider'
import { useDataGridComponent } from './useDataGridComponent'
import { useDataGridProps } from './useDataGridProps'
// import '../style/style.scss'
import { DataGridVirtualScroller } from '../components/DataGridVirtualScroller'

const DataGridRaw = React.forwardRef(function DataGrid(
  inProps: DataGridProps,
  ref: React.Ref<HTMLDivElement>
) {
  const props = useDataGridProps(inProps)
  const privateApiRef = useDataGridComponent(props, inProps)

  return (
    <GridContextProvider privateApiRef={privateApiRef} props={props}>
      <GridRoot ref={ref}>
        <GridHeaderPlaceholder />
        <GridBody VirtualScrollerComponent={DataGridVirtualScroller} />
        <GridFooterPlaceholder />
      </GridRoot>
    </GridContextProvider>
  )
})

interface DataGridComponent {
  (props: DataGridProps & React.RefAttributes<HTMLDivElement>): JSX.Element
  propTypes?: any
}

export const DataGrid = React.memo(DataGridRaw) as DataGridComponent
